export enum ROLE {
  INTERNAL_ADMIN = 'internal_admin',
  INTERNAL_SUPPORT = 'internal_support',
  MERCHANT_ADMIN = 'merchant_admin',
}